<div class="d-flex ms-4" *ngIf="userService.user">
	<div class="d-flex flex-column flex-fill">
		<div class="d-flex justify-content-between">
			<div>
				Manager Features
				<fa-icon [icon]="['far', 'circle-info']" (click)="managerFeaturesInfoPanel.toggle($event)"></fa-icon>
			</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					[disabled]="+kitchenDevice.softwareVersion <= 1.12"
					(onChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="features.manager"
				></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<div>
				Expo Station
				<fa-icon [icon]="['far', 'circle-info']" (click)="managerFeaturesInfoPanel.toggle($event)"></fa-icon>
			</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					[disabled]="+kitchenDevice.softwareVersion <= 1.12"
					(onChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="features.expo"
				></p-inputSwitch>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<div>
				Order Ready SMS
				<fa-icon [icon]="['far', 'circle-info']" (click)="orderUpInfoPanel.toggle($event)"></fa-icon>
			</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch [disabled]="userService.user.role < 5" (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="features.orderReady">
				</p-inputSwitch>
			</div>
		</div>
		<div class="d-flex justify-content-between">
			<div>
				Bump Printing On Demand Only
				<fa-icon [icon]="['far', 'circle-info']" (click)="onDemandPrinting.toggle($event)"></fa-icon>
			</div>
			<div class="d-flex justify-content-end">
				<p-inputSwitch
					[disabled]="!features.bumpToPrinterIdList || features.bumpToPrinterIdList.length === 0"
					(onChange)="changesToSaveChange.emit(true)"
					[(ngModel)]="features.kitchenBumpOnDemandOnly"
				>
				</p-inputSwitch>
			</div>
		</div>
	</div>
</div>
<div class="w-100 d-flex">
	<div class="flex-fill mx-2 mt-4">
		<div>
			<span class="p-float-label">
				<p-multiSelect
					#bumpFromDeviceList
					[disabled]="+kitchenDevice.softwareVersion <= 1.12"
					[options]="venueService.licensesKitchenDevice.value"
					optionLabel="name"
					optionValue="printerId"
					name="bumpFromDeviceList"
					[(ngModel)]="licenseBumpFromDeviceList"
					[style]="{ width: '100%' }"
					appendTo="body"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(venueService.licensesKitchenDevice.value)"
					(onChange)="kitchenDeviceBumpFromDeviceChange(); changesToSaveChange.emit(true)"
				></p-multiSelect>
				<label for="idValue">Bump From Devices</label>
			</span>
		</div>
		<div class="descriptionText text-danger" *ngIf="+kitchenDevice.softwareVersion <= 1.12">Requires Kitchen version 1.13 or higher</div>
	</div>
	<div class="flex-fill mx-2 mt-4">
		<span class="p-float-label">
			<p-multiSelect
				#bumpToPrinterIdList
				[options]="printerDeviceList"
				optionLabel="name"
				optionValue="sk"
				name="bumpToPrinterIdList"
				[(ngModel)]="features.bumpToPrinterIdList"
				[style]="{ width: '100%' }"
				appendTo="body"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(printerDeviceList)"
				(onChange)="changesToSaveChange.emit(true)"
			></p-multiSelect>
			<label for="bumpToPrinterIdList">Bump To Printer</label>
		</span>
	</div>
</div>

<p-overlayPanel #orderUpInfoPanel>
	OrderUp! will send an SMS notification to the phone number attached to the order when bumped from this station. Requires Order Ready Texting Subscription.
</p-overlayPanel>
<p-overlayPanel #managerFeaturesInfoPanel>
	Manager features include toggling items in/out of stock and changing item counts directly from Kitchen. Requires Kitchen version 1.13 or higher.
</p-overlayPanel>
<p-overlayPanel #onDemandPrinting> Store-level staff can print on demand, instead of always printing on bump. </p-overlayPanel>
